let snapshot = Object.freeze({
  view: 'schedule',
  title: '',
  subtitle: '',
  phase: 'idle',
  error: '',
});

const listeners = new Set();

export function getViewSnapshot() {
  return snapshot;
}

export function publishViewSnapshot(next) {
  snapshot = Object.freeze({ ...snapshot, ...next });
  for (const listener of listeners) listener(snapshot);
  return snapshot;
}

export function setViewHeading(title, subtitle) {
  return publishViewSnapshot({ title: String(title || ''), subtitle: String(subtitle || '') });
}

export function subscribeView(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
